import { Injectable } from '@angular/core';
import { Details } from '@details/Interfaces/details';
import { blank, simple, anchor, nameOnly } from '@details/Interfaces/details-item-types';
import { LayoutOrientation } from '@common/enums/layout-orientation';
import { LandlordDetails } from '@landlords/models/landlord-details';
import { has, DetailsBuilder } from '@details/Interfaces/details-builder';
import { as } from '@common/string-formatter/string-formatter';

@Injectable({
  providedIn: 'root'
})
export class LandlordDetailsMapperService {


  mapToDetails(details: LandlordDetails): Details {

    const showCompanySection = has(details.VatReg, details.RegisteredCompanyNumber);

    const showContactSection = has(details.ContactName,
      details.Phone,
      details.DirectPhone,
      details.MobilePhone,
      details.Email,
      details.Fax);

    const showRemittanceContact = has(details.RemittanceContactName,
      details.RemittanceEmail,
      details.RemittanceFax);

    const remittanceMethod = as(details.RemittancePreferredMethodOfContact, 'MethodOfContact');

    const correspondenceMethod = as(details.DemandsPreferredMethodOfContact, 'MethodOfContact');

    const b = new DetailsBuilder(`Reference ${details.Ref}`, details);

    b.section('Landlord', LayoutOrientation.Vertical)
      .always(nameOnly(details.Name))
      .for('StrungAddress', 'Address:');

    b.conditionalSection(showCompanySection, null, LayoutOrientation.Horizontal)
      .for('VatReg', 'Vat registration:')
      .for('RegisteredCompanyNumber', 'Registered Company No:');

    b.conditionalSection(showContactSection, 'Contact', LayoutOrientation.Horizontal)
      .for('ContactName', 'Name:')
      .telFor('Phone', 'Phone:')
      .telFor('DirectPhone', 'Direct phone:')
      .telFor('MobilePhone', 'Mobile phone:')
      .mailFor('Email', 'Email:')
      .for('Fax', 'Fax:');

    b.section('Additional Information', LayoutOrientation.Horizontal)
      .conditionalItem(showRemittanceContact, simple('Remittance contact details:', null))
      .conditionalItem(showRemittanceContact && details.RemittanceContactName, simple('Name:', details.RemittanceContactName))
      .conditionalItem(showRemittanceContact && details.RemittanceEmail, anchor('Email:', `mailto:${details.RemittanceEmail}`, details.RemittanceEmail))
      .conditionalItem(showRemittanceContact && details.RemittanceFax, simple('Fax:', details.RemittanceFax))
      .conditionalItem(remittanceMethod, simple(`Remittance is sent via ${remittanceMethod}`, null))
      .always(blank())
      .always(simple('Demands, arrears, ad-hoc contact details:', null))
      .for('DemandsContactName', 'Name:')
      .mailFor('DemandsEmail', 'Email:')
      .for('DemandsFax', 'Fax:')
      .conditionalItem(correspondenceMethod, simple(`Correspondence is sent via ${correspondenceMethod}`, null));

    return b.getDetails();
  }

}
